import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
    fallbackLocale: process.env.VUE_APP_CLOUD_I18N_FALLBACK_LOCALE || 'en',
});
export async function loadi18nLanguageAsync(lang = 'nl') {
    import(/* webpackChunkName: "lang-[request]" */ `@/locale/${lang}/i18n`)
        .then((dictionary) => {
        i18n.setLocaleMessage(lang, dictionary.default);
        i18n.locale = lang;
    });
    // import(/* webpackChunkName: "lang-[request]" */ `@/locale/${lang}/number-formats`)
    //   .then((dictionary: { default: VueI18n.NumberFormat }) => {
    //     i18n.setNumberFormat(lang, dictionary.default)
    //   })
}
export default i18n;
